import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editUser } from 'action/user'
import { Form, Modal, Button } from 'antd'
import { EXTERNAL } from 'constant/login-type'
import PropTypes from 'prop-types'
import UserForm from 'view/page/user-management/component/user-form'
import FormModal from 'view/component/form-modal'
import formatUser from 'helper/format-input-fields'
import _ from 'lodash'
import styles from './styles.scss'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.first_name} ${response.last_name} has been updated successfully.`,
  title: 'User Updated'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'There has been a issue updating user'
})

const buildSitesUserTypes = (sites, values) => {
  const siteArray = sites.map((value) => {
    if (values[value.site_name]) {
      return { site_uuid: value.uuid, user_type_uuid: values[value.site_name] }
    }
    return null
  })
  return _.compact(siteArray)
}

const EditUser = ({ sites, user, editUser, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      values.site_user_types = buildSitesUserTypes(sites, values)
      const response = await editUser({ ...values, uuid: user.uuid })
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  const readOnly = user.login_type.display_name !== EXTERNAL

  return (
    <>
      {getButton(user, setVisible)}
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(formatUser(user))
        }}
        readOnly={readOnly}
        title={readOnly ? 'View user' : 'Edit user'}
        visible={visible}
      >
        <UserForm
          form={form}
          readOnly={readOnly}
          user={formatUser(user)}
        />
      </FormModal></>
  )
}

const getButton = (user, setVisible) => (
  user.login_type.display_name === EXTERNAL
  ? <>
    <Button
      className={styles.menu_item}
      disabled={user.login_type.display_name !== EXTERNAL}
      onClick={() => setVisible(true)}
      type='text'
    >Edit User</Button>
  </>
  : <>
    <Button
      className={styles.menu_item}
      onClick={() => setVisible(true)}
      type='text'
    >View User</Button>
  </>
)

EditUser.propTypes = {
  editUser: PropTypes.func,
  sites: PropTypes.array,
  submitting: PropTypes.bool,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  sites: state.site.allSites,
  submitting: state.loader.userSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editUser: bindActionCreators(editUser, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditUser)
